import { CreatePartnerOrganizationApiKeyResponseDto, PartnerOrganizationApiKeyResponseDto, } from '@lucidlink/dto/web-service-api';
import { arrayParserFromDto, parserFromDto } from '#fetcher/parse-utils';
export const createPartnerOrganizationApiKeysManager = (partnerOrganizationFetcher) => new PartnerOrganizationApiKeysManagerImpl(partnerOrganizationFetcher);
class PartnerOrganizationApiKeysManagerImpl {
    apiKeysFetcher;
    constructor(partnerOrganizationFetcher) {
        this.apiKeysFetcher = partnerOrganizationFetcher.createSubFetcher({
            path: 'api-keys',
        });
    }
    async listKeys() {
        return this.apiKeysFetcher.get([], {
            parser: arrayParserFromDto(PartnerOrganizationApiKeyResponseDto),
        });
    }
    async createKey(params) {
        return this.apiKeysFetcher.post([], {
            body: params,
            parser: parserFromDto(CreatePartnerOrganizationApiKeyResponseDto),
        });
    }
    async deleteKey(keyId) {
        await this.apiKeysFetcher.delete([keyId.toString()]);
    }
}
